import { useEventCallback } from '@mui/material/utils';

import { useFormContextPlus } from '../../../../../containers/mask-overlays/form-plus/use-form-context-plus';

import { KEY_NAME_BY_BILLING_BY } from './constants';
import { ProjectHourBillingOverlayFormValue } from './types';

type Return = {
  selectedRecords: number[];
  toggleRecordSelectable: (id: number) => void;
};

export const useProjectHourBillingRelatedRecordsSelectability = (): Return => {
  const { watch, setValue } =
    useFormContextPlus<ProjectHourBillingOverlayFormValue>();

  const billingBy = watch('settings.billingBy');
  const keyName = KEY_NAME_BY_BILLING_BY[billingBy];
  const settings = watch('settings');
  const selectedRecords = settings[keyName];

  const toggleRecordSelectable = useEventCallback((id: number) => {
    const isSelected = selectedRecords.includes(id);
    const newSelectedRecords = isSelected
      ? selectedRecords.filter((_id) => _id !== id)
      : [...selectedRecords, id];

    setValue(
      'settings',
      { ...settings, [keyName]: newSelectedRecords },
      { shouldDirty: true }
    );
  });

  return { selectedRecords, toggleRecordSelectable };
};
